import { Alert, IconButton, Snackbar } from "@mui/material"
import React, { useContext } from "react"
import { AdminContext } from "../views/Admin"
import CloseIcon from "@mui/icons-material/Close"

const action = (setSnackbarOpen) => (
	<React.Fragment>
		<IconButton size="small" aria-label="close" color="inherit" onClick={() => setSnackbarOpen(false)}>
			<CloseIcon fontSize="small" />
		</IconButton>
	</React.Fragment>
)

const BootstrapSnackBar = () => {
	const adminContext = useContext(AdminContext)
	const snackbarOpen = adminContext.snackbarOpen
	const snackbarMessage = adminContext.snackbarMessage
	const setSnackbarOpen = adminContext.setSnackbarOpen
	const snackbarSeverity = adminContext.snackbarSeverity
	//console.log(snackbarSeverity)
	return (
		<Snackbar
			open={snackbarOpen}
			autoHideDuration={6000}
			onClose={() => setSnackbarOpen(false)}
			message={snackbarMessage}
			action={action(setSnackbarOpen)}
		>
			<Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity}>
				{snackbarMessage}
			</Alert>
		</Snackbar>
	)
}

export default BootstrapSnackBar
